export default {
  companySurveysMetadata: {
    surveys: {
      title: 'Опросы',
      periodic: 'Периодический опрос',
      nonperiodic: 'Непериодический опрос',
      report: 'Сводка',
      details: 'По отдельным пользователям',
      emplStatistic: 'Сотрудников прошли опрос',
      allQuestions: 'Все',
      createButton: 'Создать новый опрос',
      surveyDone: 'Опрос пройден',
      surveyPlaceholder: 'Пока нет назначенных или незавершенных опросов',
      table: {
        headers: {
          name: 'Название опроса',
          lastSend: 'Посл. отправка',
          nextSend: 'След. отправка',
          dateStart: 'Дата старта',
          dateEnd: 'Дата окончания',
          period: 'Период',
          count: 'Статистика',
          status: 'Статус',
        },
      },
      statuses: {
        draft: 'Черновик',
        published: 'Опубликован',
      },
      changeButton: 'Редактировать опрос',
      menu: {
        sendToParticipants: 'Назначить участников',
        sendNow: 'Оправить опрос сейчас',
        reSendNow: 'Отправить напоминание',
        makeUnavailable: 'Скрыть из доступа',
        makeAvailable: 'Сделать доступным',
        exportResults: 'Выгрузить результаты',
        copyLink: 'Скопировать ссылку',
        copyEntity: 'Скопировать опрос',
        copyEntityTo: 'Скопировать в другую компанию',
        del: 'Удалить опрос',
      },
      successMessages: {
        changeStatus: 'Доступность опроса успешно изменена',
        copyEntity: 'Копирование опроса успешно завершено',
        sendNow: 'Опрос отправлен участникам',
      },
      errorMessages: {
        changeStatus: 'Не удалось изменить доступность опроса',
        copyEntity: 'Не удалось скопировать опрос',
        sendNow: 'Не удалось отправить опрос',
        copyEntityNotSelected: 'Не выбрана ни одна компания',
      },
    },
    tests: {
      title: 'Тесты',
      unregistered: 'Незарегистрированный пользователь',
      validAnswers: 'Результат',
      periodic: 'Периодический тест',
      nonperiodic: 'Непериодический тест',
      createButton: 'Создать новый тест',
      testDone: 'Тест пройден',
      testPlaceholder: 'Пока нет назначенных тестов',
      table: {
        headers: {
          name: 'Название теста',
          lastSend: 'Посл. отправка',
          nextSend: 'След. отправка',
          dateStart: 'Дата старта',
          dateEnd: 'Дата окончания',
          period: 'Период',
          count: 'Кол-во прошедших тест',
          availability: 'Разрешено проходить гостям',
          status: 'Статус',
        },
      },
      statuses: {
        draft: 'Черновик',
        published: 'Опубликован',
      },
      changeButton: 'Редактировать тест',
      menu: {
        sendToParticipants: 'Назначить участников',
        reSendNow: 'Отправить напоминание',
        sendNow: 'Оправить тест сейчас',
        makeUnavailable: 'Скрыть из доступа',
        makeAvailable: 'Сделать доступным',
        exportResults: 'Выгрузить результаты',
        copyLink: 'Скопировать ссылку',
        copyEntity: 'Скопировать тест',
        copyEntityTo: 'Скопировать в другую компанию',
        del: 'Удалить тест',
      },
      successMessages: {
        changeStatus: 'Доступность теста успешно изменена',
        copyEntity: 'Копирование теста успешно завершено',
        sendNow: 'Тест отправлен участникам',
      },
      errorMessages: {
        changeStatus: 'Не удалось изменить доступность теста',
        copyEntity: 'Не удалось скопировать тест',
        sendNow: 'Не удалось отправить тест',
        copyEntityNotSelected: 'Не выбрана ни одна компания',
      },
    },
    availability: {
      availabilityTooltip:
        'Разрешено проходить неавторизованным пользователям. Результаты прохождения будут обезличены.',
      availabilityGuestTooltip:
        'Результаты прохождения опроса/теста не будут отображать сведения о пользователе.',
      availabilityNotGuestTooltip:
        'Результаты прохождения опроса/теста отображают сведения обо всех пользователях, если пользователь не авторизован, то его ответы будут помечены как ответы гостя.',
    },
    cycle: 'Цикл',
    totalAnswers: 'Всего ответов',
    lastAnswer: 'Последний ответ',
    individualLinks: 'Генерация индивидуальных ссылок',
    individualLinksHint:
      'Доступно при назначении участников. Участники получат индивидуальные ссылки для прохождения, авторизация не потребуется',
    questions: {
      notFound: 'Тип вопроса не распознан',
      default: '- Выберите тип вопроса -',
      boolean: 'Да или Нет',
      multi_choice: 'Мультивыбор',
      number: 'Число',
      single_choice: 'Единичный выбор',
      text: 'Короткий текст',
      date: 'Дата',
      textarea: 'Длинный текст',
      file: 'Файл',
      scale: 'Шкала',
      phone: 'Телефон',
      time: 'Время',
    },
    questionFields: {
      units: 'Единицы измерения',
      minMax: 'Мин/макс значение',
      validAnswer: 'Правильный ответ',
      showValidAnswer: 'Указать правильный ответ',
      unitsPlaceholder: 'Например: шт, кг, дней',
      from: 'От',
      to: 'До',
      decimals: 'Разрешить десятичные',
      answerVariants: 'Варианты ответа',
      scaleMaxLength: 'Максимальная длина названий: 30 символов',
      scaleMaxLengthHint:
        'Шкала будет отображаться в горизонтальном положении, в полях «Начало и конец шкалы» вы можете указать текстовые или числовые значения, с ограничением в 30 символов',
      answerVariantsPlaceholder: 'Введите название варианта ответа',
      addVariant: 'Добавить ещё вариант',
      delVariant: 'Удалить вариант',
      pointCount: 'Количество точек',
      startsWith: 'Начало со значения «1»',
      scaleBegin: 'Начало шкалы',
      scaleBeginPh: 'Введите название первой точки',
      scaleEnd: 'Конец шкалы',
      scaleEndPh: 'Введите название последней точки',
      maxLength: 'Ограничение длины',
      addFile: 'Прикрепить файл',
      addedFile: 'Прикреплённый файл',
      surveyTextQuestionLabel: 'Ответ',
      showInFeed: 'Включить отображение вопроса в ленте',
      showInFeedHint: 'Ответ будет опубликован в ленте <strong>без указания вашего имени</strong>',
      question: 'Вопрос',
      questionPlaceholder: 'Введите текст вопроса',
      qType: 'Тип вопроса',
      showRich: 'Включить расширенное описание вопроса',
      richBody: 'Расширенное описание',
      surveySettingsAdditional: 'Оценка результата не включена',
      surveySettingsAdditionalBtn: 'Включить',
      surveySettingsAdditionalLink: 'Перейти к настройке оценки результатов',
      newOption: 'Новый вариант',
      copyQuestion: 'Копировать вопрос',
      copyPrefix: 'Копия',
      editQuestion: 'Редактировать вопрос',
      deleteForever: 'Удалить без возможности восстановления',
      moveDown: 'Переместить ниже',
      moveUp: 'Переместить выше',
      restore: 'Восстановить',
      finishButtonName: 'Завершить прохождение',
      addQuestion: 'Добавить вопрос',
      deleted: 'Вопрос {num} удалён',
    },
    successMessages: {
      deleteResearchment: 'Исследование успешно удалено',
      deleteTemplate: 'Шаблон успешно удален',
      deleteSurvey: 'Опрос удалён',
      sendSurvey: 'Опрос успешно отправлен',
      changeTimetable: 'Опрос успешно изменён',
      sendTest: 'Тест успешно отправлен',
      changeTimetableTest: 'Тест успешно изменён',
      copyTemplate: 'Шаблон скопирован успешно',
      copyResearchment: 'Исследование скопировано успешно',
      createResearchment: 'Исследование создано успешно',
      createTemplate: 'Шаблон создан успешно',
      assignResearchment: 'Исследование успешно назначено',
      saveResearchment: 'Исследование сохранено',
    },
    errorMessages: {
      deleteResearchment: 'Не удалось удалить исследование',
      deleteTemplate: 'Не удалось удалить шаблон',
      sendSurvey: 'Не удалось отправить опрос',
      getTimetable: 'Нет команд в подчинении',
      changeTimetable: 'Не удалось изменить опрос',
      sendSurveyTest: 'Не удалось отправить тест',
      changeTimetableTest: 'Не удалось изменить тест',
      copyTemplate: 'Ошибка при копировании шаблона',
      copyResearchment: 'Ошибка при копировании исследования',
      createResearchment: 'Ошибка при создании исследования',
      createTemplate: 'Ошибка при создании шаблона',
      assignResearchment: 'Не удалось назначить исследование',
      saveResearchment: 'Ошибка при сохранении исследования',
    },
    confirm: {
      deleteResearchment: 'Удалить исследование?',
      ungroup: 'Прикрепленные опросы или тесты будут разгруппированы и сохранены',

      continueResearchment: 'Продолжить исследование?',
      restart:
        'Вы хотите перезапустить исследование заново, или продолжить текущий цикл?<br/><br/>В случае ручного перезапуска, существующие опросы завершатся и будут созданы новые.<br/>Так же в этом случае вам придётся также вручную проставить даты старта новых опросов и нажать кнопку запуска еще раз.',
      submitRestart: 'Да, перезапустить',
      continueCurrent: 'Продолжить текущее',
      deleteTemplate: 'Удалить шаблон?',

      deleteSurvey: 'Удалить опрос?',
      submitDelete: 'Да, удалить',
      questionDeleteSurvey:
        'Вы уверены, что хотите удалить опрос? Вместе с опросом будут удалены и все имеющиеся ответы. Действие невозможно отменить.',

      deleteRecipients: 'Удалить сотрудников?',
      excludeSurvey: 'Сотрудники будут исключены из получателей опроса',
      excludeTest: 'Сотрудники будут исключены из получателей теста',
    },
    confirmDeleteAllRecipients: {
      title: 'Удалить всех сотрудников?',
      textSurvey: 'Все сотрудники компании будут исключены из получателей опроса',
      textTest: 'Все сотрудники компании будут исключены из получателей теста',
    },
    confirmAddAllRecipients: {
      title: 'Добавить всех сотрудников?',
      textSurvey: 'Все сотрудники компании будут добавлены в получатели опроса',
      textTest: 'Все сотрудники компании будут добавлены в получатели теста',
    },
    tableHeaders: {
      title: 'Название',
      description: 'Описание',
    },
    commonHint: 'Общий шаблон',
    buttons: {
      deleteTemplate: 'Удалить шаблон',
      deleteResearchment:
        'Удаление исследования, прикрепленные опросы или тесты будут разгруппированы и сохранены',
      //было изначально так, что started - это Остановить, менять не стал
      started: 'Остановить',
      stopped: 'Запустить',
      paused: 'Продолжить',
    },
    manageTemplates: 'Управление шаблонами исследований',
    noTemplates:
      'У вас ещё нет ни одного шаблона. Чтобы создать шаблон, создайте исследование и сохраните его как шаблон',
    noSurvey:
      'У вас ещё нет ни одного опроса. Чтобы создать опрос, нажмите на кнопку «Создать новый опрос»',
    noTest:
      'У вас ещё нет ни одного теста. Чтобы создать тест, нажмите на кнопку «Создать новый тест»',
    noResearchment:
      'У вас ещё нет ни одного исследования. Чтобы создать исследование, нажмите на кнопку «Создать исследование»',
    noCompanyEmployees:
      'Для назначения опроса добавьте сотрудников в компанию. Для этого перейдите на вкладку',
    noEmployees: 'Все сотрудники уже участвуют в опросе',
    noEmployeesTest: 'Все сотрудники уже участвуют в тестировании',
    noRecipients:
      'Ещё ни один пользователь не принял участие в опросе. Пригласить участников вы можете на вкладке «Назначить»',
    noRecipientsTest:
      'Ещё ни один пользователь не принял участие в тесте. Пригласить участников вы можете на вкладке «Назначить»',
    noAnswers: 'В выбранном цикле или опросе еще нет ответов',
    guest: 'Гость',
    anonymous: 'Аноним',
    member: 'Участник',
    date: 'Дата прохождения',
    saveAsTemplate: 'Сохранить как шаблон',
    selectSurveys: 'Выберите опросы/тесты для включения в исследование',
    delFromResearchment: 'Удалить из исследования',
    changeDates: 'Изменить даты',
    dateNotDefined: 'Не задана',
    enterResearchment: 'Введите название исследования',
    enterMethodology: 'Введите описание методологии',
    repeat: 'Повторять',
    datesBlock: 'Выберите даты проведения исследования',
    accessBlock: 'Выберите, кто будет иметь доступ к прохождению опросов',
    researchments: 'Исследования',
    researchment: 'Исследование',
    statuses: {
      started: 'Запущено',
      stopped: 'Остановлено',
      paused: 'Пауза',
    },
    tabs: {
      content: 'Состав исследования',
      settings: 'Настройки',
      assign: 'Назначить',
      recipients: 'Назначенные',
    },
    researchmentSettings: 'Настройка исследования',
    warning: 'Внимание',
    anonSettings:
      'Настройки опросов будут изменены согласно настройкам исследования, кроме настройки анонимности',
    setting: 'Настройка',
    contentResearchment: 'Состав исследования',
    copy: 'Скопировать исследование',
    delete: 'Удалить исследование',
    hints: {
      description: 'Не отображается при прохождении опросов',
      date: 'С этой даты опрос/тест доступен',
      period: 'Количество дней',
      settings: 'Настройки исследования будут применены ко всем прикрепленным опросам',
      dates: 'Этими датами будут ограничены опросы внутри исследования',
      copyTemplate: 'Скопировать как шаблон',
      commonTemplate: 'Общий шаблон для всех компаний',
      selectCompany: 'Выберите компанию',
      enterResearchment: 'Введите название исследования',
      selectTemplate: 'Выберите шаблон',
      enterTemplate: 'Введите название шаблона',

      message: 'Будет вставлен в шаблон письма как сопроводительная информация',
      preview:
        'Будет отображаться в сообщениях мессенджеров, если вы поделитесь ссылкой, или опрос будет отправлен через телеграм-бота',
      directLink:
        'Обновляется после сохранения изменений. Если такое название уже есть, будет дополнена номером опроса/теста',
      showHeader: 'Будет отображаться в шапке опроса/теста',
      finishMessage: 'Будет показано пользователю, после завершения опроса/тестирования',
      showFinishPercent:
        'Если установить флажок, то пользователь сможет увидеть процент в личном кабинете',
      surveySettingsCount:
        'В подсчёте баллов участвуют только вопросы, у которых указан правильный ответ',
    },
    createResearchment: 'Создать исследование',
    total: 'Всего',
    info: 'Информация',
    action: 'Действия',
    inCurrentCycle: 'В текущем цикле №',
    managingTemplates: 'Управление шаблонами',

    assignSurvey: 'Назначение опроса',
    assignTest: 'Назначение теста',
    sendSurveyDescription:
      'Пользователи получат{first}письмо в 10:00 в дату, указанную как старт проведения опроса. Если начало опроса сегодня или ранее, то выбранные пользователи получат письма сразу, после того как вы нажмёте на кнопку «Готово»',
    sendTestDescription:
      'Пользователи получат{first}письмо в 10:00 в дату, указанную как старт проведения теста. Если начало теста сегодня или ранее, то выбранные пользователи получат письма сразу, после того как вы нажмёте на кнопку «Готово»',
    allCompany: 'На всю компанию',
    fromAllCompany: 'Удалить всех',
    first: ' первое ',

    enterName: 'Введите название',
    createTemplate: 'Создание шаблона',
    assignResearchment: 'Назначение исследования',
    appoint: 'Всем сотрудникам выбранных подразделений будет назначено исследование',
    copyInCompany: 'Копирование в другую компанию',
    selectCompanies: 'Выберите компанию или несколько, куда хотите скопировать {subj}',
    searchByName: 'Поиск по названию компании',
    passPeriod: 'Период прохождения опроса',
    sendSurvey: 'Отправить опрос?',
    sendTest: 'Отправить тест?',
    onlyFor:
      'Письма и уведомления будут отправлены только пользователям которые ранее не получили данный опрос',
    descriptionResearchment: 'Описание исследования',
    surveyEdit: {
      titleSurveyCreate: 'Создание опроса',
      titleTestCreate: 'Создание теста',
      titleSurvey: 'Редактирование опроса',
      titleTest: 'Редактирование теста',
      main: 'Настройки',
      questions: 'Вопросы',
      mailing: 'Редактировать письма',
      access: 'Доступ',
      scoring: 'Настройка оценки',
      accessBlockTitle: 'Выберите, кто будет иметь доступ к прохождению опроса',
      successInfo: 'Настройки доступа сохранены',
      subject: 'Тема письма',
      message: 'Текст',
      messageHint: 'Будет вставлен в шаблон письма как сопроводительная информация',
      messageInfo: 'Настройки писем сохранены',
      previewHint:
        'Будет отображаться в сообщениях мессенджеров, если вы поделитесь ссылкой, или опрос будет отправлен через телеграм-бота',
      directLinkHint:
        'Обновляется после сохранения изменений. Если такое название уже есть, будет дополнена номером опроса/теста',
      link: 'Ссылка на опрос',
      finishMessage: 'Сообщение при завершении прохождения',
      descriptionHint: 'Будет отображаться в шапке опроса/теста',
      finishMessageHint: 'Будет показано пользователю, после завершения опроса/тестирования',
      successCreate: '{entity} создан',
      successSettingsInfo: 'Настройки сохранены',
      preview: 'Превью для мессенджера',
      showFinishPercentHint:
        'Если установить флажок, то пользователь сможет увидеть процент в личном кабинете',
      showFinishPercent: 'Показать количество набранных баллов',
      surveyResultSettings: 'Настройка результатов',
      surveySettingsTooltip: 'Настройки системы оценки и подсчета',
      newTitleTpl: 'Новый {entity} в компании {company}',
      successAddInfo: 'Вопрос добавлен',
      successDelInfo: 'Вопрос удалён',
      successCopyInfo: 'Вопрос скопирован',
      successEnableScoringInfo: 'Включен режим оценки результатов',
      successUpdateInfo: 'Изменения сохранёны',
      successEvaluationInfo: 'Настройки оценки сохранены',
      surveySettingsCount: 'Всего вопросов с ответами',
      surveySettingsCountHint:
        'В подсчёте баллов участвуют только вопросы, у которых указан правильный ответ',
      surveySettingsSum: 'Всего баллов:',
      surveySettingsLabel: 'Оценка результата зачет/незачет',
      surveySettingsEnableTooltip:
        "Чтобы отключить оценку результата по системе зачет/незачет, снимите чекбокс и нажмите на кнопку 'Сохранить'",
      surveySettingsTimeLabel: 'Ограничить время теста',
      surveySettingsTimeTooltip:
        "Чтобы отключить ограничение времени, снимите чекбокс и нажмите на кнопку 'Сохранить'",
      surveySettingsTimeFiledLabel: 'Сколько времени выделяется на прохождение',
      surveySettingsSuccessMinimumLabel: 'Зачетный минимум',
      surveySettingsSuccessLabel: 'Зачёт',
      surveySettingsFailureLabel: 'Незачёт',
      surveySettingsDisabled:
        'Для настройки оценки, необходим хотя бы один вопрос, с заданными баллами за правильный ответ',
      surveyMinMaxScoreError:
        'Зачетный минимум не может быть больше максимального количества баллов в тесте',
      shareReportTitle: 'Поделиться аналитикой',
      answers: 'Ответы на вопросы',
    },
    sendNow: {
      onlyFor:
        'Письма и уведомления будут отправлены только пользователям которые ранее не получили данный опрос или тест',
      resend:
        'Письма и уведомления будут отправлены всем пользователям которые назначены, но не прошли данный опрос или тест',
    },
  },
};
